import { APIClient } from "helpers/api_helper";
import * as url from "../helpers/url_helper"


const api = new APIClient();

// Get List
export const getUserListApi = () => api.get(url.GET_USER, null)

// Get Detail
export const getUserDetailApi = (id: string) => api.get(`${url.GET_USER_DETAIL}/${id}`, null)

// Update user
export const updateUserApi = (id: string, payload: any) => api.put(`${url.UPDATE_USER}/${id}`, payload)

// Add user
export const addUserDetailApi = (payload: any) => api.create(url.ADD_USER, payload)

// Delete user
export const deleteUserApi = (id: string) => api.delete(`${url.DELETE_USER}/${id}`, null)

// Get by userName and email
export const getByUserName = (userName: string) => api.get(`${url.GET_USER_BY_USERNAME}/${userName}`, null)
export const getByEmail = (email: string) => api.get(`${url.GET_USER_BY_EMAIL}/${email}`, null)

// Get user role
export const getUserRole = (userID: string) => api.get(`${url.GET_USER_ROLE}/${userID}/roles`, null)